module.exports = __webpack_public_path__ + "img/Icon-whatsapp-white.dd2446b7.svg";